import LeftIcon from '@mui/icons-material/ChevronLeft'
import RightIcon from '@mui/icons-material/ChevronRight'
import IconButton from '@mui/material/IconButton'
import type { Moment } from 'moment'
import React from 'react'
import { i18n } from '../index'
import css from './Reporting.css'
type MonthDisplayProps = {
  selectedMonth: Moment
  onMonthChange: (...args: Array<any>) => any
}

const MonthDisplay = ({ selectedMonth, onMonthChange }: MonthDisplayProps) => {
  const changeMonth = (value: number) => {
    onMonthChange(value)
    scrollToPosition(window.scrollY)
  }

  const scrollToPosition = (position: number) => {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: position,
        behavior: 'smooth',
      })
    }, 500)
  }

  return (
    <h3 className={css.monthDisplayContainer}>
      {i18n.t('reporting.label.customerSales.selectedMonth')}
      <div className={css.monthDisplay}>
        <IconButton className={css.monthButton} onClick={() => changeMonth(-1)}>
          <LeftIcon />
        </IconButton>
        <div className={css.month}>{selectedMonth.format('MMMM YYYY')}</div>
        <IconButton className={css.monthButton} onClick={() => changeMonth(1)}>
          <RightIcon />
        </IconButton>
      </div>
    </h3>
  )
}

export default MonthDisplay
